import warningIcon from '../../assets/icons/delete.svg';
import { NotificationMixin } from '../../mixins';

export default {
  mixins: [NotificationMixin],
  methods: {
    async deleteSelectedRows(emptyValueForSupportOldVersion, deleteFn, showSuccess = true, message) {
      try {
        const isConfirmed = await this.confirmDeletion(message);
        if (isConfirmed) {
          await deleteFn();
          if (showSuccess) {
            this.showNotification({ type: 'success', title: this.$translate('delete'), message: this.$translate('delete_success') });
          }
        }
      } catch (err) {
        this.showNotification({ type: 'error', title: this.$translate('delete'), message: err.error ? err.error.message : null });
      }
    },
    async confirmDeletion(message) {
      const h = this.$createElement;
      const messageVNode = h('div', { class: ['delete-modal-row'] }, [
        h('div', { class: ['warning-icon-wrapper'] }, [
          h('b-img', {
            class: ['warning-icon'],
            props: {
              src: warningIcon,
            },
          }),
        ]),
        h('div', { class: ['alert-wrapper'] }, [
          h('span', this.$translate('do_you_want_to_delete_it')),
          h('span', `${this.$translate(message || 'You are about to delete data')}.`),
        ]),
      ]);

      return this.$bvModal.msgBoxConfirm([messageVNode], {
        centered: true,
        okTitle: this.$translate('delete'),
        cancelTitle: this.$translate('cancel'),
        okVariant: 'danger',
        cancelVariant: 'outline-secondary',
        modalClass: 'confirm-modal',
      });
    },
  },
};
